<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    @ok="handleOk"
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    :footer="null"
    @cancel="handleCancel"
    cancelText="关闭">
      <div class="follow-box">
        <div class="follow-qrcode">
          <img :src="qrcode" v-if="qrcode">
          <img v-else src="@/assets/driver/loading.gif"/>
        </div>
        <div class="follow-tips">
          <p>注意事项：</p>
          <p>1）拖动或复制左侧二维码发送至司机微信邀请关注；</p>
          <p>2）一人一码，请确认二维码发送至司机本人，以免造成账号安全问题</p>
        </div>
      </div>
  </j-modal>
</template>

<script>
  import { getFileAccessHttpUrl, getAction } from '@/api/manage'
  export default {
    name: 'FollowModal',
    components: {

    },
    data () {
      return {
        title:'邀请关注公众号',
        width:580,
        visible: false,
        disableSubmit: false,
        qrcode:""
      }
    },
    methods: {
      show (driverId) {
        this.visible=true;
        //if(!this.qrcode){
          let formData = {
            "id":driverId,
            "bg":driverId
          }
          getAction("/dm/dmDriver/queryCodeById",formData).then((res)=>{
            if(res.success){
              this.qrcode = getFileAccessHttpUrl(res.result.wxCode);
            }
          })
        //}
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      submitCallback(){
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel () {
        this.close()
      },handleOk(){

      }
    }
  }
</script>

<style lang="less" scoped>
  .follow-box{
    display: flex;
    gap: 25px;
  }
  .follow-qrcode img{
    width: 141px;
  }
  .follow-tips{
    font-size: 16px;
    color: rgba(125, 133, 146, 1);
  }
</style>